import { client } from "@/generated/client.gen";

export interface PeriodicTask {
  id: string;
  message: string;
  frequency: "hourly" | "daily" | "weekly" | "monthly";
  cron: string;
  new_conversation: boolean;
  one_shot: boolean;
  time_of_day: string | null;
  day_of_week: string | null;
  day_of_month: number | null;
  offset: number | null;
  created_at: string | null;
}

export interface CreatePeriodicTaskPayload {
  message: string;
  frequency: "hourly" | "daily" | "weekly" | "monthly";
  new_conversation?: boolean;
  one_shot?: boolean;
  time_of_day?: string | null;
  day_of_week?: string | null;
  day_of_month?: number | null;
  offset?: number | null;
}

export interface UpdatePeriodicTaskPayload {
  message?: string;
  frequency?: "hourly" | "daily" | "weekly" | "monthly";
  new_conversation?: boolean;
  one_shot?: boolean;
  time_of_day?: string | null;
  day_of_week?: string | null;
  day_of_month?: number | null;
  offset?: number | null;
}

export const PeriodicTasksService = {
  list(groupId: string, assistantId: string) {
    return client.get<PeriodicTask[]>({
      url: `/groups/${groupId}/assistants/${assistantId}/periodic-tasks`,
      security: [{ scheme: "bearer", type: "http" }],
    });
  },

  create(
    groupId: string,
    assistantId: string,
    body: CreatePeriodicTaskPayload
  ) {
    return client.post<PeriodicTask>({
      url: `/groups/${groupId}/assistants/${assistantId}/periodic-tasks`,
      body,
      bodySerializer: JSON.stringify,
      headers: { "Content-Type": "application/json" },
      security: [{ scheme: "bearer", type: "http" }],
    });
  },

  update(
    groupId: string,
    assistantId: string,
    taskId: string,
    body: UpdatePeriodicTaskPayload
  ) {
    return client.patch<PeriodicTask>({
      url: `/groups/${groupId}/assistants/${assistantId}/periodic-tasks/${taskId}`,
      body,
      bodySerializer: JSON.stringify,
      headers: { "Content-Type": "application/json" },
      security: [{ scheme: "bearer", type: "http" }],
    });
  },

  delete(groupId: string, assistantId: string, taskId: string) {
    return client.delete<PeriodicTask>({
      url: `/groups/${groupId}/assistants/${assistantId}/periodic-tasks/${taskId}`,
      security: [{ scheme: "bearer", type: "http" }],
    });
  },
};
